module.exports = __webpack_public_path__ + "static/media/datepicker.3eb86dac.svg";